import type { ClientPersonOwnVerificationStatusesEnum } from '@DigitaleDoerfer/digitale-doerfer-api';

import type { FeatureSetting } from '@/features/feature-management/types/featureSetting';

export const DEFAULT_CONTENT_RESTRICTION_FEATURE_VALUES: ContentRestrictionFeature['featureValues'] =
  {
    allowedStatusesAnyOf: [],
    allowedStatusesAllOf: []
  };

export type ContentRestrictionFeature = Omit<
  FeatureSetting,
  'featureValues'
> & {
  featureValues: {
    allowedStatusesAnyOf?: ClientPersonOwnVerificationStatusesEnum[];
    allowedStatusesAllOf?: ClientPersonOwnVerificationStatusesEnum[];
  };
};
